import React from 'react';

function VerifyOtpScreen({ isVisible, otpValue, otpError, isVerifying, onOtpChange, onVerify, onCancel }) {
  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10000,
      backdropFilter: 'blur(4px)'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '24px',
        maxWidth: '450px',
        width: '90%',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
        animation: 'fadeIn 0.2s ease-out'
      }}>
        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#333' }}>Verify OTP</h3>
        </div>
        <div>
          <p style={{ marginBottom: '20px', color: '#666', fontSize: '14px', lineHeight: '1.5' }}>
            Please enter the OTP sent to your device to complete card registration.
          </p>
          <div className="form-group">
            <label htmlFor="otp" style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#333' }}>One-Time Password</label>
            <input
              type="text"
              id="otp"
              name="otp"
              value={otpValue}
              onChange={onOtpChange}
              placeholder="Enter 6-digit OTP"
              maxLength="6"
              className={otpError ? 'error' : ''}
              disabled={isVerifying}
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '16px',
                border: otpError ? '2px solid #f44336' : '1px solid #ddd',
                borderRadius: '8px',
                boxSizing: 'border-box',
                textAlign: 'center',
                letterSpacing: '4px',
                fontWeight: '600'
              }}
            />
            {otpError && <span className="error-message" style={{ display: 'block', marginTop: '8px', color: '#f44336', fontSize: '13px' }}>{otpError}</span>}
          </div>
          <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
            <button
              type="button"
              className="settings-btn"
              onClick={onCancel}
              disabled={isVerifying}
              style={{ 
                width: '100%', 
                padding: '12px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: isVerifying ? 'not-allowed' : 'pointer',
                opacity: isVerifying ? 0.6 : 1
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="settings-btn save-btn"
              onClick={onVerify}
              disabled={isVerifying}
              style={{ 
                width: '100%',
                padding: '12px',
                backgroundColor: isVerifying ? '#ccc' : '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: isVerifying ? 'not-allowed' : 'pointer'
              }}
            >
              {isVerifying ? 'Verifying...' : 'Verify OTP'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyOtpScreen;
